export const events = {
  SELECT_CITY_ON_MAP: "city_map_pin_click",
  SELECT_LISTING_ON_MAP: "listing_map_impression",
  OPEN_LISTING_DETAILS_ON_MAP: "OPEN_LISTING_DETAILS_ON_MAP",
  TOGGLE_LISTINGS_VIEW_MODE_ON_MAP: "change_map_view",
  START_DRAW_ON_MAP: "start_draw_on_map",
  CANCEL_DRAW_ON_MAP: "cancel_draw_on_map",
  TOGGLE_MAP_TYPE: "change_map_type",
  USER_LOADED: "user_loaded",
  USER_LOGIN: "user_login",
  ADD_NEW_LISTING: "add_new_listing_click",
  SHOW_POPUP_SERVICE: "show_services_popup",
  CLOSE_POPUP_SERVICE: "close_services_popup",
  VIEW_LISTING_LIST: "view_listing_list",
  LISTING_MAP_PIN_IMPRESSION: "listing_map_pin_impression",
  CHANGE_LISTING_LIST_VIEW: "change_listing_list_view",
  OPEN_LISTING_LIST_FILTERS: "open_listing_list_filters",
  CHANGE_LISTING_CATEGORY: "change_listing_list_category",
  VIEW_LISTING: "view_listing",
  VIEW_LISTING_IMAGE: "view_listing_image",
  GET_LISTING_PHONE: "get_listing_phone",
  ADD_LISTING_TO_FAVORITE: "add_listing_to_favorites",
  OPEN_SHARE_LISTING_MODAL: "open_share_listing_popup",
  SHARE_LISTING: "share_listing",
  SHOW_USER_MENU: "show_user_menu",
  CLOSE_USER_MENU: "close_user_menu",
  OPEN_NOTIFS: "open_notifs",
  OPEN_USER_PROFILE: "open_user_profile",
  OPEN_REQUESTS: "open_requests",
  OPEN_FAVED_LISTINGS: "open_faved_listings",
  TOGGLE_FAV_LISTINGS: "toggle_fav_listings",
  OPEN_CONTACT_US: "open_contact_us",
  TOGGLE_CONTACT_US: "toggle_contact_us",
  SUBMIT_CONTACT_US: "submit_contact_us",
  USER_LOGOUT: "user_logout",
  OPEN_BUILDING_CALCULATOR: "open_building_calculator",
  OPEN_ADD_FEATURED: "open_add_featured",
  OPEN_SERVICES: "open_services",
  OPEN_RENT_CONTRACTS: "open_rent_contracts",
  OPEN_STATS: "open_stats",
  OPEN_CONSTRUCTION: "open_construction",
  OPEN_REPORT_LISTING_MODAL: "open_report_listing_modal",
  SUBMIT_LISTING_REPORT: "submit_listing_report",
  OPEN_PROPERTY_REGISTRATION: "open_property_registration",
  OPEN_SURVEYING_PROPERTY: "open_surveying_property",
  OPEN_LISTING_FEE: "open_listing_fee",
  DAILY_RENT_RESERVE: "daily_rental_reserve_button",
  DAILY_RENT_MODE: "daily_rental_mode",
};
